<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Produit du centre de chèque postaux" />
            <CentreCheque />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import CentreCheque from '../Services/CentreCheque'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'CentreChequePage',
    components: {
        NavBar,
        PageTitle,
        CentreCheque,
        FooterComp,
    }
}
</script>